var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ArrowUpThin = function ArrowUpThin(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 10 6' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'v'
      ),
      React.createElement('path', { d: 'M1 5l4-4 4 4', stroke: 'currentColor', fill: 'none', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default ArrowUpThin;
//# sourceMappingURL=ArrowUpThin.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ArrowUpThin.js